/** @jsxImportSource @emotion/react */

import { useLazyQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { FC, useEffect, useState } from 'react'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import {
  findAllFlashCardGroup,
  findAllFlashCardGroupVariables,
  findAllFlashCardGroup_findAllFlashCardGroup_items as IGroup,
} from '__generatedTypes__/findAllFlashCardGroup'
import { ClassroomTabEnum } from '__generatedTypes__/globalTypes'
import { FIND_ALL_FLASH_CARD_GROUP } from 'queries/flashCardsGroup'
import { usePlatformsAndSubjects, Props as UsePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { SubjectTabs } from 'components/SubjectsTabs'
import FlashCardsContent from './FlashCardsContent'
import * as classes from './styles'

const platformsAndSubjectsProps: UsePlatformsAndSubjects = {
  filterSubjects: (subject) => !!subject.classroomTab.find(({ tabEnum }) => tabEnum === ClassroomTabEnum.FlashCards),
}

const FlashCards: FC = () => {
  const { subjects, selectedSubject, selectSubject } = usePlatformsAndSubjects(platformsAndSubjectsProps)
  const [groups, setGroups] = useState<IGroup[]>([])

  const [getGroups, { data: groupsData }] = useLazyQuery<findAllFlashCardGroup, findAllFlashCardGroupVariables>(
    FIND_ALL_FLASH_CARD_GROUP
  )

  useEffect(() => {
    selectedSubject &&
      getGroups({
        variables: {
          query: {
            take: TAKE_ALL_ITEMS_COUNT,
            where: {
              subject: {
                id: selectedSubject.id,
              },
            },
          },
        },
      })
  }, [selectedSubject])

  useEffect(() => {
    groupsData && setGroups(groupsData?.findAllFlashCardGroup.items || [])
  }, [groupsData])

  if (!selectedSubject) {
    return null
  }

  return (
    <div css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Flash Cards
      </Typography>
      <SubjectTabs subjects={subjects} selectedSubject={selectedSubject} selectSubject={selectSubject} />
      <FlashCardsContent groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    </div>
  )
}

export default FlashCards
